/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface FindByCustomerHatcheryId$Params {
  customerId: number;
}

export function findByCustomerHatcheryId(http: HttpClient, rootUrl: string, params: FindByCustomerHatcheryId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
  const rb = new RequestBuilder(rootUrl, findByCustomerHatcheryId.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerHatchery>>;
    })
  );
}

findByCustomerHatcheryId.PATH = '/api/customer/hatchery/{customerId}';
